import { jsxs as C, jsx as t } from "react/jsx-runtime";
import { u as p, a as m } from "./index-6a632112.mjs";
import { h as f } from "./hTag-40b23797.mjs";
import { AspectRatio as W } from "./aspectRatio.js";
import { c as i } from "./index-98c703e1.mjs";
import "./accordion.js";
import "./addressInput.js";
import "./avatar.js";
import "./badge.js";
import "./breadcrumb.js";
import "./button.js";
import "./checkbox.js";
import "./creditCardInput.js";
import "./datePicker.js";
import "./drawer.js";
import "./iconButton.js";
import "./inLineAlert.js";
import "./numberInputField-f9611118.mjs";
import "./inLineText.js";
import "./link.js";
import "./list.js";
import "./grid.js";
import "./menu.js";
import "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import "./pageHeader.js";
import "./progressBar.js";
import "./pagination.js";
import "./phoneInput.js";
import "./popupTip.js";
import "./radio.js";
import "./search.js";
import "./select.js";
import "./selectInput.js";
import "./skeleton.js";
import "./globalStyles.js";
import "./progressTracker.js";
import "./snackbarProvider-078e9a24.mjs";
import "./spinner.js";
import "./switch.js";
import "./tabs.js";
import "./tags.js";
import "./textArea.js";
import "./textInput.js";
import "./tooltip.js";
import "./topBanner.js";
import "./blogVideo.js";
import "./heroVideo.js";
import "./landingHeroVideo.js";
import "./landingPageVideo.js";
import "./modalVideo.js";
import "./videoPlayer.js";
import "./card.js";
import "./cookieSetting-8ba5aff4.mjs";
import "./themes-5f0b3c3d.mjs";
import "react";
import "./divider.js";
import "./cookieBanner.js";
import "./slot.js";
import "./dropdownMenu.js";
import "./slider.js";
import "./filter.js";
import "./showMoreLess.js";
import "./timePickerInput.js";
import "./dataList.js";
import "./globalAttributeBar.js";
import "./fileupload.js";
import "./searchInputLocation.js";
import "./photoGalleryThumbnail.js";
import "./donutChart.js";
import "./heatMapChart.js";
import "./barChart.js";
import "./columnChart.js";
import "./raisedSurface.js";
import "./photosGalleryLightbox.js";
import { Image as g } from "./image.js";
import "./segmentControl-ba90067e.mjs";
import "./segmentControlV1.js";
import "./mediaDisclosureButton.js";
import "./disclosure.js";
import "./screenReaderOnly.js";
import "./chip.js";
import "./closeButton.js";
import "./featureText-e2973bdc.mjs";
import "./jumplink.js";
import "./currencyInput.js";
import "./heroVideoV1.js";
import "./landingHeroVideoV1.js";
import "./uniqueId-321287e8.mjs";
import "./table.js";
import "./tableSearchView-b79fee3d.mjs";
import "./tableContainer-cf101627.mjs";
import "./progressTrackerVertical.js";
import "./textDisclosure.js";
import "./readOnlySection.js";
import "./index-39f84169.mjs";
import "./marketingComparisonTableMobileView-a94f5b2a.mjs";
import "./ctaButton.js";
import "./marketingDataList.js";
import "./marketingList.js";
import "./_commonjsHelpers-d4512b9c.mjs";
import "./caretUp-e6db3a6f.mjs";
import "./types-b577bf77.mjs";
import "./lineHeights-72d3110c.mjs";
import "./accessibility.js";
import "./superScript-393c70dc.mjs";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./label-3b996c7d.mjs";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./cancelClose-87fdf326.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./moreVertical-dc2e97a2.mjs";
import "./searchInputLocation.const-9a2c3a62.mjs";
import "./caretLeft-980c1667.mjs";
import "./cancelCloseFilled-b2127cb6.mjs";
import "./edit-054ba80e.mjs";
import "react-dom";
import "./caretRight-e0ea6357.mjs";
import "./caretDown-8ff83493.mjs";
import "./playFilled-b880efda.mjs";
import "./oldPlay-2e470880.mjs";
import "./pause-316ed38b.mjs";
import "./ChildrenCountCheck-60cafda6.mjs";
import "./createOptions-4792754a.mjs";
import "./debounce.js";
const S = p.div`
  &.SelectionCard-wrapper {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.Wrapper)};
  }
`, u = p(f)`
  &.TitleWrapper {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.TitleContainer)};
  }
`, D = p.p`
  &.DescriptionWrapper {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.DescriptionContainer)};
  }
`, P = p.div`
  &.MediaElement {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.MediaElementWrapper)};
  }
`, E = p.div`
  &.BodyWrapper {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.BodyWrapper)};
  }
`, T = p.div`
  &.IconContainer {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.IconContainer)};
  }
`, w = p.div`
  &.TrailingElementWrapper {
    ${({
  theme: {
    components: { selectionCard: r }
  }
}) => m(r.FordProDefaultSelectionCard.TrailingElementWrapper)};
  }
`, Zo = ({
  selected: r = !1,
  onClick: c,
  disabled: a = !1,
  alignContents: l = "center",
  media: o,
  titleProp: n,
  description: s,
  trailingElement: d,
  ...h
}) => /* @__PURE__ */ C(
  S,
  {
    tabIndex: 0,
    onClick: (e) => {
      a || c(e);
    },
    onKeyDown: (e) => {
      (e.key === "Enter" || e.key === " ") && (e.preventDefault(), !a && c(e));
    },
    className: i([
      "SelectionCard-wrapper",
      a && "SelectionCard-wrapper--disabled",
      !a && r && "SelectionCard-wrapper--selected",
      "SelectionCard-wrapper",
      o?.imageProp?.ratio !== "2/1" && "SelectionCard-wrapper--imageContainer",
      `SelectionCard-wrapper--${l}Aligned`
    ]),
    ...h,
    children: [
      o?.imageProp && /* @__PURE__ */ t(
        P,
        {
          className: i([
            "MediaElement",
            !o.imageProp.ratio || o.imageProp.ratio === "1/1" ? "MediaElement--fixedContainer" : "MediaElement--withRadius"
          ]),
          children: /* @__PURE__ */ t(
            W,
            {
              ratio: o.imageProp.ratio || "1/1",
              objectFit: "cover",
              className: "media",
              children: /* @__PURE__ */ t(
                g,
                {
                  src: { url: o.imageProp.src, alt: o.imageProp.alt }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ C(
        E,
        {
          className: i([
            "BodyWrapper",
            a && "BodyWrapper--disabled",
            `BodyWrapper--${l}Aligned`
          ]),
          children: [
            o?.iconProp && /* @__PURE__ */ t(T, { className: i(["IconContainer--xxLarge"]), children: o?.iconProp?.element }),
            n && /* @__PURE__ */ t(
              u,
              {
                as: n?.headingLevel || "h1",
                className: i([
                  "TitleWrapper",
                  { "TitleWrapper--xlarge": n?.titleSize === "xLarge" }
                ]),
                children: n?.title
              }
            ),
            s && /* @__PURE__ */ t(D, { className: i(["DescriptionWrapper"]), children: s }),
            d && /* @__PURE__ */ t(
              w,
              {
                className: i(["TrailingElementWrapper"]),
                children: d
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  Zo as SelectionCard
};
